import styled from "@emotion/styled";

export const Wrapper = styled.div`
  -webkit-tap-highlight-color: transparent;

  position: sticky;
  left: 100%;
  bottom: 40px;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;

  background-color: ${({ theme }) => theme.colors.secondary.lines};
  opacity: 0.5;
  border-radius: 50%;
  box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
  cursor: pointer;

  transition:
    opacity 0.3s ease-in-out,
    scale 0.3s ease-in-out;

  :hover {
    opacity: 1;
    scale: 1.05;
  }

  :active {
    background-color: ${({ theme }) => theme.colors.secondary.minor};
  }
`;

export const ArrowIcon = styled.img`
  transform: rotate(-90deg);
  width: 24px;
  height: 24px;
`;
